/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export const SET_AUTOPLAY_NEXT_EPISODE_OPTIONS_LIST = 'SET_AUTOPLAY_NEXT_EPISODE_OPTIONS_LIST';
export const SET_AUTOPLAY_NEXT_EPISODE_SELECTED_OPTION =
    'SET_AUTOPLAY_NEXT_EPISODE_SELECTED_OPTION';
